import { createContext, useContext } from 'react';

export type SelectionApi = {
  /** Current set of selected asset IDs */
  selectedIds: ReadonlySet<string>;
  /** Number of selected items (=== selectedIds.size, exposed for ergonomics) */
  count: number;
  /** True if id is in selection */
  has: (id: string) => boolean;
  /** Toggle a single id (cmd-click / checkbox-click) */
  toggle: (id: string) => void;
  /**
   * Range-select from last anchor to clicked id, using the current `allIds`
   * order as reference. If no anchor exists, falls back to `toggle(id)`.
   */
  selectRange: (id: string, allIds: readonly string[]) => void;
  /**
   * Add or remove many ids at once (select-all header checkbox). `selected:true`
   * adds all, `false` removes all — leaves ids not in the list untouched.
   */
  setMany: (ids: readonly string[], selected: boolean) => void;
  /** Clear selection completely */
  clear: () => void;
};

export const SelectionContext = createContext<SelectionApi | null>(null);

export function useSelection(): SelectionApi {
  const ctx = useContext(SelectionContext);
  if (!ctx) throw new Error('useSelection() benötigt einen <SelectionProvider> im Tree.');
  return ctx;
}
